{
    "name": "Air filters: 34.6 kg required, 12.5 kg planned and confirmed",
    "requests": [
        {
            "id": "539f18a8-4950-4e59-8af3-68fc435ad76a",
            "snapshot": {
                "supplier_id": "scenario-supplier",
                "status": "SENT",
                "sent_at": "2026-11-05T10:00:00Z",
                "requested_pickup": {
                    "date": "2026-11-06",
                    "time": "09:00"
                },
                "requested_delivery": {
                    "date": "2026-11-09"
                },
                "ship_from": {
                    "id": "SCENARIO-MUNICH",
                    "address": {
                        "name": "Scenario supplier Munich",
                        "street": "Demo Street 1",
                        "city": "Munich",
                        "postal_code": "80992",
                        "country_code": "DE"
                    }
                },
                "ship_to": {
                    "id": "SCENARIO-NUREMBERG",
                    "address": {
                        "name": "Scenario plant Nuremberg",
                        "street": "Demo Street 1",
                        "city": "Nuremberg",
                        "postal_code": "90402",
                        "country_code": "DE"
                    }
                },
                "place_of_discharge_id": "LOCAL-DOCK",
                "load_type": "LTL",
                "source_goods_ids": ["b67c26c4-178a-4ad5-963c-69134be9447e"],
                "handling_units": [
                    {
                        "articles": [
                            {
                                "article_number": "SCENARIO-FILTER-001",
                                "quantity": "12.5",
                                "unit": "kilogram",
                                "article_name": "Air filter"
                            }
                        ],
                        "length_mm": 1200,
                        "width_mm": 800,
                        "height_mm": 1000,
                        "gross_weight_kg": "17.5"
                    }
                ],
                "referenced_requested_amounts": [
                    {
                        "article_number": "SCENARIO-FILTER-001",
                        "quantity": "34.6",
                        "unit": "kilogram",
                        "article_name": "Air filter"
                    }
                ],
                "original_required_delivery": {
                    "date": "2026-11-09"
                },
                "supplier_name": "Scenario supplier Munich",
                "storage_place_id": "SCENARIO-R01"
            }
        }
    ],
    "transports": [
        {
            "id": "641f08b8-f9e6-4728-8806-4f0f540c96e4",
            "snapshot": {
                "id": "641f08b8-f9e6-4728-8806-4f0f540c96e4",
                "confirmation_id": "4b3ebf89-82ba-417b-b777-bf8b309b1b12",
                "supplier_id": "scenario-supplier",
                "requested_pickup_date": "2026-11-06",
                "consignments": [
                    {
                        "id": "27c1ff5f-0525-485b-b44a-df6d15fae4e4",
                        "handling_units": [
                            {
                                "id": "51790989-64d7-482d-a4f5-074014cb0648",
                                "included_in_transport_demand_of_load_with_id": "539f18a8-4950-4e59-8af3-68fc435ad76a",
                                "packaging_id": "216a81eb-a339-4dd8-9ca0-3a84c678de43",
                                "ship_from": {
                                    "id": "SCENARIO-MUNICH",
                                    "address": {
                                        "name": "Scenario supplier Munich",
                                        "street": "Demo Street 1",
                                        "city": "Munich",
                                        "postal_code": "80992",
                                        "country_code": "DE"
                                    }
                                },
                                "ship_to": {
                                    "id": "SCENARIO-NUREMBERG",
                                    "address": {
                                        "name": "Scenario plant Nuremberg",
                                        "street": "Demo Street 1",
                                        "city": "Nuremberg",
                                        "postal_code": "90402",
                                        "country_code": "DE"
                                    }
                                },
                                "place_of_discharge": {
                                    "id": "LOCAL-DOCK"
                                },
                                "loads": [
                                    {
                                        "type": "specified",
                                        "article_number": "SCENARIO-FILTER-001",
                                        "quantity": "12.5",
                                        "unit": "kilogram"
                                    }
                                ],
                                "storage_place": {
                                    "id": "SCENARIO-R01"
                                }
                            }
                        ]
                    }
                ],
                "transport_number": "SCENARIO-FILTER-001",
                "requested_pickup_time": "09:00",
                "carrier": {
                    "carrier_name": "Scenario carrier"
                }
            }
        }
    ]
}
